import axios from "axios";

const baseUrl: string = "/api/v0/user"

export interface UserUpdateModel {
    name: string;
    oldPassword: string;
    newPassword: string;
}

export interface UserCreateModel {
    userName: string;
    fullName: string;
    password: string;
    passwordAgain: string;
}

export interface UserCreateResponseModel {
    success: boolean;
    userId?: string;
    reason?: string;
}

export interface UserApi {
    getUser: (userId: string) => Promise<{ id: string, userName: string }>;
    getCurrentUser: () => Promise<{ id: string, userName: string }>;
    updateUser: (userId: string, model: UserUpdateModel) => Promise<void>;
    createUser: (model: UserCreateModel) => Promise<UserCreateResponseModel>;
}

const userApi: UserApi = {
    getUser: async (userId: string) => {
        const { data } = await axios.get(`${baseUrl}/${userId}`);
        return data;
    },

    getCurrentUser: async () => {
        const { data } = await axios.get(`${baseUrl}`);
        return data;
    },

    updateUser: async (userId: string, model: UserUpdateModel) => await axios.patch(`${baseUrl}/${userId}`, model),

    createUser: async (model: UserCreateModel) => {
        const { data } = await axios.post<UserCreateResponseModel>(`${baseUrl}`, {
            email: model.userName,
            name: model.fullName,
            password: model.password,
        });
        return data;
    }
}

export default userApi;